"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_native_1 = require("react-native");
var AutoLayoutViewNativeComponent = react_native_1.View;
exports.default = AutoLayoutViewNativeComponent;
//# sourceMappingURL=AutoLayoutViewNativeComponent.js.map